export type UserReportDirection = "TEEN_INITIATED" | "MENTOR_INITIATED";
export type UserReportStatus = "OPEN" | "CLOSED";

export interface UserReportUser {
  id: string;
  name: string | null;
  profile_picture_url?: string | null;
  redacted_fields?: string[];
}

export interface UserReport {
  id: string;
  direction: UserReportDirection;
  category: string | null;
  categoryLabel: string | null;
  reason: string | null;
  priority: string;
  status: UserReportStatus;
  reporter: UserReportUser | null;
  reportedUser: UserReportUser | null;
  mentorshipId: string | null;
  conversationId: string | null;
  createdAt: string;
  feedbackCorrect: boolean | null;
  resolutionNote: string | null;
  resolvedBy: { id: string; name: string | null } | null;
  resolvedAt: string | null;
}

export const DIRECTION_LABELS: Record<UserReportDirection, string> = {
  TEEN_INITIATED: "Teen-initiated",
  MENTOR_INITIATED: "Mentor-initiated",
};
